import { ContractSummaryRecord } from "models/view-models/contracts/contract-summary-record";
import { ServiceHookFactory } from "andculturecode-javascript-react";

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint: string = "organizations/:organizationId/contracts/oll/summaries";
const pastTrainingsEndpoint: string = `${baseEndpoint}/pasttrainings`;
const resourceType: typeof ContractSummaryRecord = ContractSummaryRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ListOrganizationOLLContractSummariesPathParams {
    organizationId: number;
    skip?: number;
    take?: number;
}

export interface ListOrganizationOLLContractSummariesQueryParams {}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const OrganizationOLLContractSummariesService = {
    /**
     * Custom hook for leveraging service index calls in React components
     */
    useList: ServiceHookFactory.useNestedList<
        ContractSummaryRecord,
        ListOrganizationOLLContractSummariesPathParams,
        ListOrganizationOLLContractSummariesQueryParams
    >(resourceType, baseEndpoint),

    usePastTrainingsList: ServiceHookFactory.useNestedList<
        ContractSummaryRecord,
        ListOrganizationOLLContractSummariesPathParams,
        ListOrganizationOLLContractSummariesQueryParams
    >(resourceType, pastTrainingsEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { OrganizationOLLContractSummariesService };

// #endregion Exports
